import { Button, Form, Modal } from "antd";
import TextArea from "antd/es/input/TextArea";
import { enqueueSnackbar } from "notistack";
import { useState } from "react";
import { ApprovalEmailLicense, ApprovalLicense, axiosErrorMessages } from "../../../API/api";
import axios, { AxiosError } from "axios";
interface AddSoftwareVersion {
  taskType:string;
  licensingId: number
  onClose: () => void;
}
const RejectReason: React.FC<AddSoftwareVersion> = ({taskType, onClose, licensingId }) => {

  const [isOpen, setIsOpen] = useState<boolean>(true)
  const [rejectReasonForm] = Form.useForm()
  const onClosePopup = () => {
    setIsOpen(false)
    onClose()
  }
  const onSaveHandler = (formData: any) => {
    const statusId = 3
    if(taskType === 'email'){
      ApprovalEmailLicense(licensingId, statusId, formData.comments)
      .then((response: any) => {
        enqueueSnackbar("Rejected the Task", {
          variant: 'success', anchorOrigin: {
            vertical: 'top',
            horizontal: 'right',
          },
        })
        onClose();
      }).catch((error: any) => {
        let errorMsg;
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          errorMsg = axiosErrorMessages(axiosError);
        } else {
          errorMsg = error.message;
        }
        enqueueSnackbar(errorMsg, {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        });
        // enqueueSnackbar("Error in fetching data", {
        //   variant: 'error', anchorOrigin: {
        //     vertical: 'top',
        //     horizontal: 'right',
        //   },
        // })
      })
    }
  else{
    ApprovalLicense(licensingId, statusId, formData.comments)
    .then((response: any) => {
      enqueueSnackbar("Rejected the Task", {
        variant: 'success', anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
      })
      onClose();
    }).catch((error: any) => {
      let errorMsg;
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        errorMsg = axiosErrorMessages(axiosError);
      } else {
        errorMsg = error.message;
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      // enqueueSnackbar("Error in fetching data", {
      //   variant: 'error', anchorOrigin: {
      //     vertical: 'top',
      //     horizontal: 'right',
      //   },
      // })
    })
  }
    
  }
  return <>
    <Modal footer={false} maskClosable={false} onCancel={onClosePopup} open={isOpen} title="Task Reject Reason">

      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 12 }}
        style={{ maxWidth: 1000 }}
        onFinish={onSaveHandler}
        autoComplete="off"
        form={rejectReasonForm}
      >
        <Form.Item
          rules={[{ required: true, message: "Enter Reason" }]}
          name="comments"
        >
          <TextArea  rows={4} placeholder="Enter Reason" />
        </Form.Item>
        <Button className="pm-btn" htmlType="submit" type="primary" >
          Save
        </Button>
      </Form>
    </Modal>
  </>
}

export default RejectReason;